import styled from 'styled-components'
import { Modal, Form, Row } from 'react-bootstrap'
import colorConfig from '../../colorConfig'
import Cleave from "cleave.js/react";

//const _orange = '#f19568'
const bg_color = colorConfig.modal_background;
const font_color = colorConfig.lys_gul;

// Bakgrunnen blir slør over resten av siden
const StyledModal = styled(Modal)`
    // Definerer siden rundt comboen
    color: ${colorConfig.lys_gul} !important;            
`
const StyledModalHeader = styled(Modal.Header)`  
    border-bottom: 0px;
    background-color: ${bg_color};
    color: #fff;      
    border-top-right-radius: 1.50em;
    border-top-left-radius: 1.50em; 
`
const StyledModalBody = styled(Modal.Body)`        
    background-color: ${bg_color};
    color: ${colorConfig.mork};    
    border: 30px solid ${bg_color};
    padding-bottom: 0px;
    margin-bottom: 0px;    
    font-family: "RM Neue", "sans-serif";
    font-size: 20px !important;
    
    input {
      border-radius: 0.5em;
      font-family: "RM Neue", "sans-serif";
      font-size: 20px !important;
      border: none ;
      color: black;
    };
    input[type=file] {
        color: ${colorConfig.mork};   
    };
    Textarea {
      border-radius: 0.5em;
      font-family: "RM Neue", "sans-serif";
      font-size: 20px !important;
      border: none ;
      color: black;
    };
    Row {
        padding-top: 32px !important;            
    };     
    Form.Group {
        padding-bottom: 10px !important;            
    };     
    label {
        padding-top: 20px;
        font-size: 20px;
        font-weight: 700;
        color: ${colorConfig.mork};              
    }; 
    div & div & label {
        font-family: "RM Neue", "sans-serif";
        font-size: 20px !important;
        color: ${colorConfig.mork};             
    };
    h4 {
        font-family: "Documan", "sans-serif";
        color: ${colorConfig.mork};
        font-size: 30px;
        font-weight: 400;         
    }
    p {
        color: ${colorConfig.mork};
        font-weight: 500;         
    }
`
const StyledModalFooter = styled(Modal.Footer)`    
    background-color: ${bg_color};
    color: ${colorConfig.mork};  
    border-top: 0px;
    border-bottom: 20px solid ${bg_color};
    border-left: 30px solid ${bg_color};
    border-right: 30px solid ${bg_color};
    padding-top: 0px;
    justify-content: flex-start;
    && > button {
        border-radius: 0.5em;
        background-color: ${colorConfig.button_bg};
        color: black;
        font-weight: 500;
        &:hover {
            background-color: ${colorConfig.button_focused};
            color: black;
        }
        &:focus {
            background-color: ${colorConfig.button_focused};
        }
        &:disabled {
            background-color: gray;
            color: lightGray;
        }
      
    }

    p {
        color: ${colorConfig.mork};
        font-weight: 500;
        font-family: "RM Neue", "sans-serif";         
    }
`

const SquareInput = styled(Form.Control)`    
    border: none;
    border-radius: 0.5em;
`

const SquareInputStyled = styled(Cleave)`
  font-size: 20px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const ModalP = styled.span`
    font-size: 20px !important;
`

export { StyledModal, StyledModalHeader, StyledModalBody, StyledModalFooter, SquareInput, SquareInputStyled, ModalP }